import { Box, constants, Skeleton, Text } from '@redbubble/design-system';
import { FormattedMessage } from '@redbubble/next/intl';
import styles from './PageHeading.module.scss';

const Separator = () => <span className={styles.separator} />;

export const PageHeadingSkeleton: React.FC = () => {
  return (
    <Box className={styles.wrapper} display="flex">
      <Text element="h1" type="display2" textAlign={constants.CENTER}>
        <FormattedMessage defaultMessage="Shopping Cart" />
      </Text>
      <Box
        className={styles.details}
        display="flex"
        flexDirection="row"
        alignItems="stretch"
      >
        <Skeleton width={64} animated />
        <Separator />
        <Skeleton width={64} animated />
      </Box>
    </Box>
  );
};
